import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Component } from "react";

am4core.useTheme(am4themes_animated);

class LineChart extends Component {
  state = {
    chart: null,
    dateAxis: null,
    height: "260px",
    width: "100%",
  };
  componentDidMount() {
    const chart = am4core.create("lineChart" + this.props.id, am4charts.XYChart);
    this.createChart(chart);
    this.setState(() => ({ chart }));
    if (!!this && !!this.props && !!this.props.height && this.props.height !== "") {
      this.setState({
        height: this.props.height,
      });
    }
    if (!!this && !!this.props && !!this.props.width && this.props.width !== "") {
      this.setState({
        width: this.props.width,
      });
    }
  }
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
  createChart = (chart) => {
    chart.data = !!this.props.data && this.props.data !== 0 ? this.props.data : [];
    let categoryAxis = chart.xAxes.push(new am4charts.DateAxis());
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.fontSize = "10px";
    categoryAxis.thickness = "0px";
    categoryAxis.renderer.grid.template.disabled = true;
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.fontSize = "12px";
    categoryAxis.tooltip.fontSize = "12px";
    valueAxis.tooltip.fontSize = "12px";
    valueAxis.cursorTooltipEnabled = false; //disables x axis black tooltips
    categoryAxis.cursorTooltipEnabled = false; //disalbes y axis black tooltips
    categoryAxis.skipEmptyPeriods = true;
    valueAxis.skipEmptyPeriods = true;
    if (!!this.props && !!this.props.country && this.props.country === "usanalytics") {
      chart.dateFormatter.inputDateFormat = "MMM YYYY";
      categoryAxis.paddingBottom = -20;
      valueAxis.renderer.labels.template.fontSize = 10;
      valueAxis.title.text = this.props.mainLabel ? (this.props.mainLabel === "% of shipments" ? "Shipments" : this.props.mainLabel === "% of weight" ? "Weight (kg)" : this.props.mainLabel === "% of TEUs" ? "TEUs" : this.props.mainLabel) : "";
      valueAxis.numberFormatter = new am4core.NumberFormatter();
      valueAxis.numberFormatter.numberFormat = "#a"; //formats from 1e+9 into B instead of G
      valueAxis.numberFormatter.bigNumberPrefixes = [
        { number: 1e3, suffix: "K" },
        { number: 1e6, suffix: "M" },
        { number: 1e9, suffix: "B" },
        { number: 1e12, suffix: "T" },
      ];
    }
    if (chart.data.length >= 2) {
      categoryAxis.periodChangeDateFormats.setKey("month", "[bold]yyyy[/]");
    } else {
      categoryAxis.dateFormats.setKey("day", "MMM YYYY");
      categoryAxis.periodChangeDateFormats.setKey("day", "[bold]MMM YYYY[/]");
    }
    // Create series
    let dataArray = this?.props?.data || [];
    let lastItem = dataArray.length > 0 ? dataArray[dataArray.length - 1] : null;

    let series = chart.series.push(new am4charts.LineSeries());
    series.tooltip.fontSize = "12px";

    const getTooltipText = (isLastItem) => {
      if (!!this.props.mainLabel && !!this.props.country && this.props.country === "usanalytics") {
        let tooltipText = "";
        let unit = "";

        switch (this.props.mainLabel) {
          case "% of shipments":
            unit = "Shipments";
            tooltipText = `{key}:\n {value} ${unit}`;
            break;
          case "% of weight":
            unit = "kg";
            tooltipText = `{key}:\n {value} ${unit}`;
            break;
          case "% of TEUs":
            unit = "TEUs";
            tooltipText = `{key}:\n {value} ${unit}`;
            break;
          case "Weight (kg)":
            unit = "kg";
            tooltipText = `{key}:\n {value} ${unit}`;
            break;
          default:
            unit = this.props.mainLabel;
            tooltipText = `{key}:\n {value} ${unit}`;
        }

        return isLastItem ? `{key}:\n {value} ${unit}\nTrends are updated to the latest shipment date` : tooltipText;
      }
      return isLastItem ? `{key}: [b]{value}[/]\nTrends are updated to the latest shipment date` : "{key}: [b]{value}[/]";
    };

    series.adapter.add("tooltipText", (tooltipText, target) => {
      if (!target?.tooltipDataItem?.dataContext?.key || !lastItem?.key) {
        return "{key}: [b]{value}[/]";
      }

      const isLastItem = target.tooltipDataItem.dataContext.key === lastItem.key;
      return getTooltipText(isLastItem);
    });

    series.dataFields.valueY = "value";
    series.dataFields.dateX = "key";
    series.strokeWidth = 1;

    if (!!this.props && !!this.props.country && this.props.country === "usanalytics") {
      series.numberFormatter = new am4core.NumberFormatter();
      series.numberFormatter.smallNumberThreshold = 0.0001;
      series.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
      series.numberFormatter.bigNumberPrefixes = [
        { number: 1e3, suffix: "K" },
        { number: 1e6, suffix: "M" },
        { number: 1e9, suffix: "B" },
        { number: 1e12, suffix: "T" },
      ];
      let hoverState = series.states.create("hover");
      hoverState.properties.fill = am4core.color("#6f08f1");
      hoverState.properties.fillOpacity = 0.8;
      series.adapter.add("fill", function () {
        return am4core.color("#ece7f9");
      });
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#271c45");
      series.tooltip.background.strokeWidth = 0;
    }
    let circleBullet = series.bullets.push(new am4charts.CircleBullet());
    circleBullet.circle.radius = 2;
    series.fill = am4core.color(!!this.props && !!this.props.color && this.props.color !== "" ? this.props.color : "#1C59DE");
    series.stroke = am4core.color(!!this.props && !!this.props.color && this.props.color !== "" ? this.props.color : "#1C59DE");
    series.fillOpacity = am4core.color(!!this.props && !!this.props.color && this.props.color !== "" ? this.props.color : "#1C59DE");
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineY.disabled = true;
    chart.cursor.lineX.disabled = true;
    chart.cursor.behavior = "none";
  };

  render() {
    return (
      <div className="w-100">
        <div id={"lineChart" + this.props.id} style={{ width: this.state.width, height: this.state.height }} />
      </div>
    );
  }
}

export default LineChart;
